export init from './init';
export reducer from './reducer';
export Component from './components/Component';



/** WEBPACK FOOTER **
 ** ./src/app/modules/app/index.js
 **/